import { render, staticRenderFns } from "./ButtonWidgetPanel.vue?vue&type=template&id=5189acdf&scoped=true"
import script from "./ButtonWidgetPanel.vue?vue&type=script&lang=js"
export * from "./ButtonWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonWidgetPanel.vue?vue&type=style&index=0&id=5189acdf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189acdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5189acdf')) {
      api.createRecord('5189acdf', component.options)
    } else {
      api.reload('5189acdf', component.options)
    }
    module.hot.accept("./ButtonWidgetPanel.vue?vue&type=template&id=5189acdf&scoped=true", function () {
      api.rerender('5189acdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/ButtonWidgetPanel.vue"
export default component.exports